import { render, staticRenderFns } from "./SolicitacoesServicosTabs.vue?vue&type=template&id=4a7624ae"
import script from "./SolicitacoesServicosTabs.vue?vue&type=script&lang=js"
export * from "./SolicitacoesServicosTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports